import { MeetingConnectorContextState, useMeetingConnectorContext } from "./meetingConnector";

export interface MeetingConnectorRendererProps {
  render: (state: MeetingConnectorContextState) => React.ReactNode;
}

export const MeetingConnectorRenderer = ({ render }: MeetingConnectorRendererProps) => {
  const meetingConnectorCtx = useMeetingConnectorContext();
  return <>{render(meetingConnectorCtx)}</>;
};